import { onDocumentReady } from "@story/story_assets";
import "@story/story_assets/slide";

import "@story/story_assets/ajax";
import "@story/story_assets/ajax_form";
import "@story/story_assets/turnstile";
import "@story/story_assets/modal/modal";
import "@story/story_assets/modal/modal_dialog";
import "@story/story_assets/modal/modal_window";

onDocumentReady(() => {
	const menuIcon = document.querySelector(".menu-icon");
	const navLinks = document.querySelector(".nav-links");

	if (menuIcon && navLinks) {
		const toggleMenu = () => {
			navLinks.classList.toggle("show-menu");

			const isExpanded = menuIcon.getAttribute("aria-expanded") === "true";
			menuIcon.setAttribute("aria-expanded", !isExpanded);
		};

		menuIcon.addEventListener("click", toggleMenu);
	}
});

onDocumentReady(() => {
	const select = document.querySelector("#job_application_job_position_id");
	const nameField = document.querySelector("#job_application_name");
	const form = document.querySelector("#application");

	if (!select || !form) {
		return;
	}

	document.querySelectorAll("[data-position-id]").forEach((button) => {
		button.addEventListener("click", (event) => {
			event.preventDefault();

			select.value = button.dataset.positionId;
			form.scrollIntoView({ behavior: "smooth", block: "start" });

			if (nameField) {
				nameField.focus({ preventScroll: true });
			}
		});
	});
});


let lastScrollTop = 0;
const offset = 100;

window.addEventListener("scroll", () => {
	const documentHeight = document.documentElement.scrollHeight;
	const windowHeight = window.innerHeight;
	const scrollPosition = window.scrollY;

	if (scrollPosition > offset) {
		if (scrollPosition > lastScrollTop) {

			document.querySelector(".navbar").classList.add("hidden");
		} else {

			document.querySelector(".navbar").classList.remove("hidden");
		}
	} else {

		document.querySelector(".navbar").classList.remove("hidden");
	}

	lastScrollTop = scrollPosition <= 0 ? 0 : scrollPosition;
}, {
	passive: true
});
